module.exports = __webpack_public_path__ + "f4741611cfc3ae30307102b515f6efce.jpg";